import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  animate, animateChild, query, style, transition, trigger
} from '@angular/animations';
import { WizardService, INTAKE_FLOW_SLUGS } from '@sondermind/flows-host';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'flows-host-router',
  templateUrl: './host-router.component.html',
  styleUrls: [
    './host-router.component.scss',
  ],
  animations: [
    trigger('fadeRouter', [
      transition('* => true', [
        style({ background: 'rgba(255,255,255,0)' }),
        query('@fade, @fadeHeader', [
          animateChild()
        ], { optional: true }),
        animate('450ms ease', style({ background: 'rgba(255,255,255,1)' })),
      ]),
      transition('* => false', [
        style({ background: 'rgba(255,255,255,1)' }),
        query('@fade, @fadeHeader', [
          animateChild()
        ], { optional: true }),
        animate('200ms ease', style({ background: 'rgba(255,255,255,0)' })),
      ]),
    ]),
  ]
})
export class HostRouterComponent implements OnInit, OnDestroy {
  private destroyedSubj: Subject<void> = new Subject<void>();

  destroyed$: Observable<void> = this.destroyedSubj.asObservable();
  isIntakeHost: boolean;

  constructor(
    public wizard: WizardService,
  ) { }

  ngOnInit(): void {
    this.wizard.response$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(
      (resp) => {
        this.isIntakeHost = INTAKE_FLOW_SLUGS.includes(resp?.slug);
      }
    );
  }

  ngOnDestroy(): void {
    this.destroyedSubj.next();
    this.destroyedSubj.complete();
  }
}
